import useTranslate from '../../../i18n/useTranslate'
import { Form as FinalForm } from 'react-final-form'
import { Button, Grid, makeStyles } from '@material-ui/core'
import { DocumentSopRequest } from '../../../services/um/useResearcherDocument'
import MyTextfield from '../../../control/textfield/textfield'
import Select from '../../../control/select/select'
import useIRBDownloadDocument from '../../../services/um/lookups/useIRBDownloadDocument'

type ResearcherDocumentPanelComponentProps = {
    onSubmit: (value: DocumentSopRequest) => void
    initialValue: DocumentSopRequest
    onClear: (form: any) => void
}

const Panel = ({ onSubmit, initialValue, onClear }: ResearcherDocumentPanelComponentProps) => {
    const classes = useStyles()
    const translate = useTranslate()
    // ใช้ lut แยกของหน้านี้ การเปิด/ปิดว่าให้เลือก REC ไหนได้ คุมอยู่ใน SP
    const { irb } = useIRBDownloadDocument()
    // ไม่ตั้ง default ให้ ผู้ใช้ต้องเลือก REC เองก่อน (field เป็น required) ไม่งั้นมันจะกระทบเวลาค้นหา
    const defaultREC = initialValue.rec ? [initialValue.rec.toString()] : []

    return (
        <Grid className={classes.root}>
            <FinalForm onSubmit={onSubmit} initialValues={initialValue}>
                {({ handleSubmit, form }) => {
                    return (
                        <Grid container spacing={2} className={classes.container}>
                            <Grid item xs={12} md={6}>
                                <Select
                                    name="rec"
                                    option={irb}
                                    label={translate.get('UM.RESEARCHER_DOC.REC')}
                                    placeholder={translate.get('LABEL.PLEASE_SELECT')}
                                    size="small"
                                    defaultValue={defaultREC}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <MyTextfield
                                    name="search"
                                    materialInputProps={{
                                        disabled: false,
                                        label: translate.get('LABEL.SEARCH_BY_KEYWORD'),
                                        placeholder: translate.get('LABEL.DOCUMENT_NAME'),
                                        size: 'small',
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify="flex-end" spacing={2}>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="default"
                                            onClick={() => onClear(form)}
                                        >
                                            {translate.get('BUTTON.RESET')}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            {translate.get('BUTTON.SEARCH')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </Grid>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        padding: '1.7rem',
    },
    root: {
        width: '100%',
    },
}))

export default Panel
